module.exports = __webpack_public_path__ + "assets/img/node.6dbb7878.png";